import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { BodyPrimary, H2 } from '@liveauctioneers/hammer-ui-core/text';
import React, { useMemo } from 'react';

import { shortFormatDate } from '@/utils/dates';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export const packengersPolicyLastUpdatedTimeStamp = 1648227762; // March 25, 2022
const packengersEmail = 'helloNYC@thepackengers.com';

export const PackengersPolicy = () => {
    const formatMessage = useAppFormatMessage();

    const policyRichTextValues = useMemo(() => {
        let newlineSerial = 0;
        let listItemSerial = 0;
        let strongSerial = 0;
        let subListItemSerial = 0;
        return {
            email: (
                <Link
                    key="packengers-policy-email"
                    href={`mailto:${packengersEmail}`}
                >
                    {packengersEmail}
                </Link>
            ),
            h2: (content: React.ReactNode) => <H2 key="packengers-policy-h2">{content}</H2>,
            ListItem: (content: React.ReactNode) => (
                <div
                    className="inline-block pl-md -indent-md"
                    key={`packengers-policy-li-${listItemSerial++}`}
                >
                    <span>{content}</span>
                </div>
            ),
            newline: () => <br key={`packengers-policy-nl-${newlineSerial++}`} />,
            strong: (content: React.ReactNode) => (
                <strong key={`packengers-policy-s-${strongSerial++}`}>{content}</strong>
            ),
            SubListItem: (content: React.ReactNode) => (
                <div
                    className="inline-block pl-xl -indent-md"
                    key={`packengers-policy-sli-${subListItemSerial++}`}
                >
                    <span>{content}</span>
                </div>
            ),
        };
    }, []);

    return (
        <>
            <div>
                <BodyPrimary color="secondary">
                    {formatMessage(['partners', 'lastUpdated'], {
                        values: { date: shortFormatDate(packengersPolicyLastUpdatedTimeStamp) },
                    })}
                </BodyPrimary>
            </div>
            <div>
                {formatMessage(['partners', 'packengers', 'policy'], {
                    values: policyRichTextValues,
                })}
            </div>
        </>
    );
};
